import React, { useCallback, useRef, useEffect, useState } from 'react'
import ResultSearchAnnouncementTable from './components/ResultSearchAnnouncementTable';
import Footer from '../../components/footer/Footer';
import { Button } from 'primereact/button';
import currencyAnnouncementApiService from '../../services/currencyAnnouncementApiService';
import RegisterModal from '../../components/auth-modal/RegisterModal';
import LoginModal from '../../components/auth-modal/LoginModal';
import moneyAnnouncementApiService from '../../services/moneyAnnouncementApiService';
import { TabMenu } from 'primereact/tabmenu';
import { useNavigate, useOutletContext } from 'react-router-dom';
import AnnouncementCard from '../home/components/AnnouncementCard/AnnounceCard';
import { t } from 'i18next';
import './SearchAnnouncePage.css'
import OtpVerificationModal from '../../components/auth-modal/OtpVerificationCodeModal';
import useWindowSize from '../../components/layout/WindowResize';
import { useTranslation } from 'react-i18next';


const SearchAnnouncePage = ({ }) => {
    const [key, setKey] = useState(0); // State to force re-render
    const { t, i18n } = useTranslation();
    const [announcementsAboutMoney, setAnnouncementsAboutMoney] = useState([])
    const [announcementsAboutCurrency, setAnnouncementsAboutCurrency] = useState([])
    const [zone, setZone] = useState({})
    const [currencyModel, setCurrencyModel] = useState({})
    const [moneyModel, setMoneyModel] = useState({})
    const [showCurrencyAnnounce, setShowCurrencyAnnounce] = useState(false);
    const [showAllAnnounce, setShowAllAnnounce] = useState(false);
    const emptyMessageForSearchAnnouncement = "Aucune annonce présente pour le moment. Veuillez cliquer sur le bouton (+) à côté du titre pour laisser une annonce dans la plateforme.";
    const emptyMessageForSearchZone = "Aucune annonce présente pour la zone sélectionnée.";
    const [userLogged, setUserLogged] = useState(false)
    const [showLoginModal, setShowLoginModal] = useState(false)
    const [showCard, setShowCard] = useState(false)
    const [showRegisterModal, setShowRegisterModal] = useState(false)
    const [user, setUser] = useState({})
    const [showOtpVerificationModal, setShowOtpVerificationModal] = useState(false)
    const [width, height] = useWindowSize();

    const [ownerOfAnnouncementId, setOwnerOfAnnouncementId] = useState('')
    const [announcementId, setAnnouncementId] = useState('')
    const navigate = useNavigate();

    const { showSuccessMessage, showErrorMessage } = useOutletContext();


    // Listen for language changes and force re-render
    useEffect(() => {
        const handleLanguageChange = () => {
            setKey(prevKey => prevKey + 1); // Increment key to force re-render
        };

        i18n.on('languageChanged', handleLanguageChange);

        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n]);

    useEffect(() => {
        let user = JSON.parse(localStorage.getItem("user"));
        if (user && user?.id) {
            setUser(user);
            setUserLogged(true);
        }

        if (sessionStorage.getItem('search-by-zone') == 'true') {
            setZone(JSON.parse(sessionStorage.getItem('zone')))
            let result = JSON.parse(sessionStorage.getItem('zones-result'));
            setShowAllAnnounce(true);
            if (result != null) {
                setAnnouncementsAboutMoney([...(result.exchangeMoneyAnnouncements)])
                setAnnouncementsAboutCurrency([...(result.exchangeCurrencyAnnouncements)])
            }
        } else {
            setShowAllAnnounce(false);
            if (sessionStorage.getItem('search-about-money') == 'true') {
                setMoneyModel(JSON.parse(sessionStorage.getItem('moneyModel')) ?? {});
                let result = JSON.parse(sessionStorage.getItem('search-money-announce')) ?? [];
                setShowCurrencyAnnounce(false);
                setAnnouncementsAboutMoney([...(result)])
            } else {
                let result = JSON.parse(sessionStorage.getItem('search-currency-announce')) ?? [];
                setCurrencyModel(JSON.parse(sessionStorage.getItem('currencyModel')) ?? {});
                setShowCurrencyAnnounce(true);
                setAnnouncementsAboutCurrency([...(result)])
            }
        }

        setShowCard(true)
    }, [])

    const searchResultCallBack = async (announceModel, announceResult) => {
        if (showAllAnnounce) {
            setAnnouncementsAboutCurrency(announceResult.exchangeMoneyAnnouncements)
            setAnnouncementsAboutMoney(announceResult.exchangeCurrencyAnnouncements)
        } else {
            if (showCurrencyAnnounce) {
                setCurrencyModel(announceModel)
                setAnnouncementsAboutCurrency(announceResult)
            } else {
                setMoneyModel(announceModel)
                setAnnouncementsAboutMoney(announceResult)
            }
        }
    }


    const saveMoneyAnnouncement = async (idUser) => {
        moneyModel.userId = idUser;
        let response = await moneyAnnouncementApiService.createAnnoucement(moneyModel);

        if (response?.id) {
            sessionStorage.clear();
            showSuccessMessage({
                title: t('searchPage.announceSave'), message: t('searchPage.announceSaveMessage')
            });
            navigate('/profil');
        } else {
            showErrorMessage({
                title: t('searchPage.announceNotSave'), message: response.error ?? t('searchPage.problemOccurredAtThisLevel')
            });
        }
    }

    const writeAboutAnnounce = (annonceId, userOwnerId) => {
        setAnnouncementId(annonceId)
        setOwnerOfAnnouncementId(userOwnerId)

        if (!userLogged) {
            setShowLoginModal(true)
        } else {
            navigate("/message-detail/announce/" + annonceId + "/sender/" + user?.id + "/owner/" + userOwnerId)
        }
    }

    const saveCurrencyAnnouncement = async (idUser) => {
        currencyModel.userId = idUser;
        let response = await currencyAnnouncementApiService.createAnnoucement(currencyModel);

        if (response?.id) {
            sessionStorage.clear();
            showSuccessMessage({
                title: t('searchPage.announceSave'), message: t('searchPage.announceSaveMessage')
            });
            navigate('/profil');
        } else {
            showErrorMessage({
                title: t('searchPage.announceNotSave'), message: response.error ?? t('searchPage.problemOccurredAtThisLevel')
            });
        }
    }

    const detailOfSearch = ({ textColor }) => {
        return <div className={textColor + ' ' +(textColor.length > 0 ? '' : 'p-0 ') + 'col-12 ' + (showAllAnnounce ? '' : 'md:col-6')} >
            {
                showAllAnnounce ? (
                    <p className={textColor + 'mt-0 mb-4 md:text-2xl'}>{t('searchPage.searchAllAnnounces')} : <strong>{zone.name}</strong> </p>
                ) : (
                    <div className='mb-4'>
                        {
                            showCurrencyAnnounce ? (
                                <p className={textColor + 'mt-0 mb-2 md:text-2xl'}>{t('searchPage.searchFrom')} : <strong>{currencyModel?.exchangeCity?.name}</strong> </p>
                            ) : (
                                <p className={textColor + 'mt-0 mb-2 md:text-2xl'}>
                                    {t('searchPage.searchFrom')} : <strong>{moneyModel?.cityWhereHeSent?.name}</strong>  {t('global.to')}  <strong>{moneyModel?.cityWhereHeRetrieve?.name}</strong>
                                </p>
                            )
                            // showCurrencyAnnounce ? (
                            //     <p className={textColor + 'mt-0 mb-2 md:text-2xl'}>{t('searchPage.searchLinkToCurrency')} : <strong>{currencyModel?.exchangeCity?.name}</strong> </p>
                            // ) : (
                            //     <p className={textColor + 'mt-0 mb-2 md:text-2xl'}>
                            //         {t('searchPage.searchLinkToMoney')} : <strong>{moneyModel?.cityWhereHeSent?.name}</strong>  {t('global.to')}  <strong>{moneyModel?.cityWhereHeRetrieve?.name}</strong>
                            //     </p>
                            // )
                        }

                        <p className={textColor + ' mt-0 mb-2'} >{t('searchPage.amountToSend')} <strong>{moneyModel?.cityWhereHeSent?.name ? moneyModel?.amountToSend + ' ' + moneyModel?.currencyFrom : currencyModel?.amountToSend + ' ' + currencyModel?.currencyFrom}</strong></p>
                        <p className={textColor + ' mt-0 mb-2'} >{t('searchPage.amountToReceive')} <strong>{moneyModel?.cityWhereHeSent?.name ? moneyModel?.amountToRetrieve + ' ' + moneyModel?.currencyTo : currencyModel?.amountToRetrieve + ' ' + currencyModel?.currencyTo}</strong></p>
                        <p className={textColor + ' mt-0 mb-2'} >{t('searchPage.rate')} <strong>{moneyModel?.cityWhereHeSent?.name ? moneyModel?.rate : currencyModel?.rate}</strong></p>
                    </div>
                )
            }
        </div>
    }

    return (
        <div className="search-page page flex flex-column min-h-screen" >
            <div className="search-container flex-grow-1">
                <div className='header mb-4'>
                    <div className='toolbar relative'>
                        <div className='absolute z-1  h-full w-full overflow-hidden'>
                            <div className='h-full w-full relative z-5'>
                                <div className='image-container z-1 h-full w-full'>
                                    <div className='image-content h-full w-full'>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='text-content relative z-5 px-4 md:px-6 '>
                            <div className={(showAllAnnounce ? 'search-for-all-options ' : '') + 'toolbar-content max-width-container mx-auto'} >
                                <div className='grid py-5'>
                                    {
                                        width > 587 ? detailOfSearch({
                                            textColor: 'text-white'
                                        }) : ''
                                    }

                                    {
                                        showAllAnnounce ? (
                                            ''
                                        ) : (
                                            <div className='col-12 md:col-6'>
                                                {showCard ? (
                                                    <AnnouncementCard
                                                        showSuccessMessage={({ title, message }) => {
                                                            showSuccessMessage({
                                                                title: title, message: message
                                                            });
                                                        }}
                                                        showErrorMessage={({ title, message }) => {
                                                            showErrorMessage({
                                                                title: title, message: message
                                                            });
                                                        }}
                                                        searchResultOntheSamePageCallBack={searchResultCallBack} showSearchResultOntheSamePage={true} announceObject={showCurrencyAnnounce ? currencyModel : moneyModel} textFieldClass={'text-white'} showIndex={showCurrencyAnnounce ? 1 : 0} />
                                                ) : ('')}
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className='px-4 md:px-6 pt-0  pb-4 md:pb-6'>
                    {
                        width <= 587 ? detailOfSearch({
                            textColor: ''
                        }) : ''
                    }


                    <div className='max-width-container mx-auto'>
                        {
                            showAllAnnounce ? (
                                <>
                                    <div className='mb-6'>
                                        {
                                            announcementsAboutMoney.length > 0 ? (
                                                <h4 className='mb-4 text-xl'>{t('searchPage.announceLinkToMoney')} </h4>
                                            ) : ''
                                        }
                                        <ResultSearchAnnouncementTable writeAboutAnnounce={writeAboutAnnounce} showCurrencyAnnouncement={false} showSaveAnnouncementBtn={false} emptyMessage={emptyMessageForSearchZone} announcements={announcementsAboutMoney} />
                                    </div>
                                    <div>
                                        {
                                            announcementsAboutCurrency.length > 0 ? (
                                                <h4 className='mb-4 text-xl'>{t('searchPage.announceLinkToCurency')}</h4>
                                            ) : ''
                                        }
                                        <ResultSearchAnnouncementTable writeAboutAnnounce={writeAboutAnnounce} showCurrencyAnnouncement={true} showSaveAnnouncementBtn={false} emptyMessage={emptyMessageForSearchZone} announcements={announcementsAboutCurrency} />
                                    </div>
                                </>
                            ) : (
                                showCurrencyAnnounce ? (
                                    <div>
                                        <div className='flex mb-4 justify-content-between align-items-center flex-wrap'>
                                            {
                                                announcementsAboutCurrency.length > 0 ? (
                                                    <h4 className='m-0 text-xl'>{t('searchPage.announceLinkToCurencyFound')} </h4>
                                                ) : ''
                                            }
                                        </div>
                                        <ResultSearchAnnouncementTable writeAboutAnnounce={writeAboutAnnounce} showCurrencyAnnouncement={true} showSaveAnnouncementBtn={true} emptyMessage={emptyMessageForSearchAnnouncement} saveAnnouncement={() => !userLogged ? setShowLoginModal(true) : saveCurrencyAnnouncement(user.id)} announcements={announcementsAboutCurrency} />
                                    </div>
                                ) : (
                                    <div className='mb-6'>
                                        <div className='flex mb-4 justify-content-between align-items-center flex-wrap'>
                                            {
                                                announcementsAboutMoney.length > 0 ? (
                                                    <h4 className='m-0 text-xl'>{t('searchPage.announceLinkToMoney')} </h4>
                                                ) : ''
                                            }


                                        </div>
                                        <ResultSearchAnnouncementTable writeAboutAnnounce={writeAboutAnnounce} showCurrencyAnnouncement={false} showSaveAnnouncementBtn={true} saveAnnouncement={() => !userLogged ? setShowLoginModal(true) : saveMoneyAnnouncement(user.id)} emptyMessage={emptyMessageForSearchAnnouncement} announcements={announcementsAboutMoney} />
                                    </div>
                                )

                            )
                        }
                    </div>
                </div>
            </div >
            {
                showLoginModal ? <LoginModal
                    showSuccessMessage={({ title, message }) => {
                        showSuccessMessage({
                            title: title, message: message
                        });
                    }}
                    showErrorMessage={({ title, message }) => {
                        showErrorMessage({
                            title: title, message: message
                        });
                    }}
                    onSubmit={(logUser) => {
                        setUser(logUser);
                        setUserLogged(true);
                        if (announcementId.length > 3) {
                            navigate("/message-detail/announce/" + announcementId + "/sender/" + logUser?.id + "/owner/" + ownerOfAnnouncementId)
                        } else {
                            if (showCurrencyAnnounce) {
                                saveCurrencyAnnouncement(logUser.id)
                            } else {
                                saveMoneyAnnouncement(logUser.id)
                            }
                        }
                    }} open={showLoginModal} openCreateModal={() => { setShowLoginModal(false); setShowRegisterModal(true); }} onClose={() => setShowLoginModal(false)} /> : ''
            }

            {
                showRegisterModal ? <RegisterModal
                    showSuccessMessage={({ title, message }) => {
                        showSuccessMessage({
                            title: title, message: message
                        });
                    }}
                    showErrorMessage={({ title, message }) => {
                        showErrorMessage({
                            title: title, message: message
                        });
                    }}
                    open={showRegisterModal} onSubmit={(logUser) => {
                        // setUser(logUser);
                        // setUserLogged(true);
                        setShowOtpVerificationModal(true);
                    }} openLoginModal={() => { setShowRegisterModal(false); setShowLoginModal(true); }} onClose={() => setShowRegisterModal(false)} /> : ''
            }

            {
                showOtpVerificationModal ? <OtpVerificationModal
                    showSuccessMessage={({ title, message }) => {
                        showSuccessMessage({
                            title: title, message: message
                        });
                    }}
                    showErrorMessage={({ title, message }) => {
                        showErrorMessage({
                            title: title, message: message
                        });
                    }}
                    open={showOtpVerificationModal} onSubmit={(logUser) => {
                        setUser(logUser);
                        setUserLogged(true);
                        setShowOtpVerificationModal(false);
                    }} onClose={() => setShowOtpVerificationModal(false)} /> : ''
            }
            <Footer />
        </div >
    );
}

export default SearchAnnouncePage;
